export const INSURANCE_VALIDATION_CHANGE =
    '@@withInsuranceValidation/INSURANCE_VALIDATION_CHANGE';

export const triggerInsuranceValidationChanged = (insuranceIsAccepted) => ({
    type: INSURANCE_VALIDATION_CHANGE,
    payload: {
        insuranceIsAccepted,
    },
});
